<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter-no" id="ch-1"><a id="page_11">1</a></h1><a id="page_11">
<p class="para">M<span class="smallcaps">Y</span> M<span class="smallcaps">OTHER LIES</span> in the ornate master bedroom of Arnold’s penthouse flat. The room overlooks Hyde Park, and from other windows in the apartment you can see Wellington Arch and even the tops of trees in the gardens of Buckingham Palace. The bedroom is peaceful and clean and smells of flowers and talcum powder.</p>
<p class="indent-para">Bridget brushes my mother’s hair and applies touches of moisturizer and make up to her face. If you stand outside the door you can hear them talking.</p>
<p class="indent-para">“Here, Mommella,” Bridget says. “Today we’re putting on eye shadow. A little here. A little there.”</p>
<p class="indent-para">“I don’t feel good,” my mother says.</p>
<p class="indent-para">“Don’t you want to look beautiful?” Bridget says.</p>
<p class="indent-para">“For whom am I supposed to look beautiful?” my mother asks wryly.</p>
<p class="indent-para">Bridget smiles. My mother has not completely lost her sense of humor.</p>
<p class="indent-para">“For me,” Bridget suggests. “And for Danny. He’s visiting, don’t you remember?”</p>
<p class="indent-para">“Danny’s here? In Durban?”</p>
<p class="indent-para">Bridget is taken aback, but just for a moment. She could say, may be tempted to say, “We’re not in Durban, Mom. We’re in London,” but she doesn’t.</p>
<p class="indent-para">“Of course he’s here,” she says instead. “You saw him yesterday.”</p>
</a><p class="indent-para"><a id="page_11"></a><a id="page_12">“I don’t remember,” Helga says. “I don’t remember anything. I feel like shit.”</a></p><a id="page_12">
<p class="indent-para">“Don’t swear now,” Bridget says, a mocking firmness in her voice. “And hold still. How am I supposed to make you beautiful if you bob around all the time?”</p>
<p class="indent-para">“Where’s Arnold?” Helga asks meekly, and not for the first time.</p>
<p class="indent-para">“He’s in the next room,” Bridget says, not wholly convincingly. “He’ll be in later.”</p>
<p class="indent-para">“Why doesn’t he spend time with me?” Helga asks.</p>
<p class="indent-para">“He does, Mommella,” Bridget says calmly. “He’ll be in soon.”</p>
<p class="indent-para">He won’t, of course. He may be her husband—her second husband that is, not Bridget’s and my father—but while our mother lies day in and day out in a large carved bed in the room she once shared with him, until Bridget arrives to be with her she spends most of her time alone.</p>
<p class="indent-para">What has made Bridget stay so much longer than she had intended is the thought of my mother lying alone in that large, airy room.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 008_Chapter01.vue?08b7e9a9